import 'bootstrap/dist/css/bootstrap.css';
import { BrowserRouter } from 'react-router-dom';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import rootReducer from './reducers';
import keycloak from './tools/keycloak';

const store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

keycloak.init({ onLoad: 'login-required', promiseType: 'native', checkLoginIframe: false }).then(authenticated => {

    if (!authenticated) {
        window.location.reload();
    } else {
        console.info("Authenticated", keycloak);
    }

    console.log("keycloak", keycloak)

    const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
    const rootElement = document.getElementById('root');

    ReactDOM.render(
        <Provider store={store}>
            <BrowserRouter basename={baseUrl}>
                <App />
            </BrowserRouter>
        </Provider>,
        rootElement);

    sessionStorage.setItem('authentication', keycloak.token);
    sessionStorage.setItem('refreshToken', keycloak.refreshToken);

    //to regenerate token on expiry
    setInterval(() => {
        keycloak.updateToken(70);


    }, 30000)

})